import React, { PureComponent } from 'react'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import { Button } from '@components/Button'
import { Tab } from './Tab'
import { TabContent } from './TabContent'
import {
  TabularNavWrapper,
  ActionsWrapper,
  MainBar,
  TabsWrapper,
  TabContentTransition,
  TRANSITION_DELAY,
} from './TabularNav.elements'

const tabPanelId = 'tabular-nav-panel'

type Props = {
  navGroups: NavGroupType[]
  onItemSelect?: () => void
  onLogin: () => void
}

type State = {
  openedNavKey: string | null
}

export class TabularNav extends PureComponent<Props, State> {
  state: State = {
    openedNavKey: null
  }
  private wrapperRef: React.RefObject<HTMLDivElement>;

  content?: HTMLDivElement

  setContentRef = (element: HTMLDivElement | null) => {
    this.content = element || undefined
  }

  constructor(props) {
    super(props);
    this.wrapperRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (this.state.openedNavKey !== null && !this.wrapperRef?.current?.contains(event.target)) {
      this.setState({ openedNavKey: null});
    }
  }

  removeContentHeight = () => {
    const content = this.content
    if (!content) return
    content.style.height = ''
  }

  setContentHeight = () => {
    const content = this.content
    if (!content) return
    content.style.height = content.scrollHeight + 'px'
  }

  handleTabChange = (tabKey: string) => () => {
    this.setState(prevState => ({
      openedNavKey: prevState.openedNavKey === tabKey ? null : tabKey
    }))
  }

  render() {
    const { navGroups, onItemSelect, onLogin } = this.props
    const { openedNavKey } = this.state

    const activeTabContent = navGroups.find(group => group.key === openedNavKey)

    return (
      <TabularNavWrapper ref={this.wrapperRef}>
        <MainBar>
          <TabsWrapper role="tablist">
            {navGroups.map(group => (
              <Tab
                key={group.key}
                title={group.title}
                isActive={openedNavKey === group.key}
                onActivate={this.handleTabChange(group.key)}
                tabPanelId={tabPanelId}
              />
            ))}
          </TabsWrapper>

          <TabsWrapper minWidth={'22%'}>
            <Button
              variant="text"
              onClick={onLogin}
            >
              Member Login
            </Button>

            <Button
              variant="text"
              onClick={() => window.location.href = '/signup' }
            >
              Join
            </Button>
          </TabsWrapper>
        </MainBar>

        <TransitionGroup>
          {activeTabContent && (
            <CSSTransition
              in={!!activeTabContent}
              onEnter={this.setContentHeight}
              onEntered={this.removeContentHeight}
              onExit={this.setContentHeight}
              onExiting={this.removeContentHeight}
              timeout={TRANSITION_DELAY}
              key={activeTabContent ? 'opened' : 'closed'}
            >
              {(state: string) => (
                <TabContentTransition
                  id={tabPanelId}
                  role="tabpanel"
                  state={state}
                  ref={this.setContentRef}
                >
                  <TabContent
                    content={activeTabContent}
                    onItemSelect={onItemSelect}
                  />
                </TabContentTransition>
              )}
            </CSSTransition>
          )}
        </TransitionGroup>
      </TabularNavWrapper>
    )
  }
}
